import { APPLICANT_ATTRIBUTIONS } from 'cpool-constants';
import { schemaId } from 'cpool-schemas';
import { z } from 'zod';

import type { EventSchema } from '../../../utils/EventSchema';
import { _Event } from '../../_Event';

export class LoanRequest_DocumentsRecorded extends _Event {
    constructor(payload: EventSchema<LoanRequest_DocumentsRecorded>, deprecated = false) {
        super(payload, deprecated);
    }

    getSchema() {
        return z.object({
            attribution: z.nativeEnum(APPLICANT_ATTRIBUTIONS),
            documents: z
                .array(
                    z.object({
                        fileExtension: z.string().optional(),
                        key: z.string().min(1),
                        mimeType: z.string().min(1),
                        name: z.string().min(1),
                    }),
                )
                .min(1),
            documentsWithErrors: z.array(z.string()).nullish(),
            uploader: schemaId.optional().nullable(), // this is the UserId of the uploader or undefined for an applicant
        });
    }

    static example() {
        return {
            attribution: APPLICANT_ATTRIBUTIONS.ANTRAGSTELLER_1,
            documents: [
                {
                    fileExtension: 'pdf',
                    key: 'document-key-1',
                    mimeType: 'application/pdf',
                    name: 'Document 1',
                },
            ],
            uploader: 'bae74890-14af-4593-b06e-91771eb7a525',
        } satisfies EventSchema<LoanRequest_DocumentsRecorded>;
    }
}
